import { Card, PropertyList, PropertyListItem, Tag } from '@humanforce/mango-ui-react';
import type { PublicHolidayDto } from './publicHolidayTypes';

const formatDate = (value: string | null) => value ? new Date(`${value.slice(0, 10)}T00:00:00`).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' }) : '—';

export const PublicHolidayDayDetail = ({ holiday }: { holiday?: PublicHolidayDto }) => holiday ? <Card title={holiday.name}>
  <PropertyList>
    <PropertyListItem label="Date">{formatDate(holiday.holidayDate)}</PropertyListItem>
    <PropertyListItem label="Scope"><Tag label={holiday.jurisdictionCode ?? holiday.scope} tone="grey" /></PropertyListItem>
    <PropertyListItem label="Jurisdiction">{holiday.jurisdictionCode ?? 'National'}</PropertyListItem>
    <PropertyListItem label="Observed date">{formatDate(holiday.observedDate)}</PropertyListItem>
    <PropertyListItem label="Partial day">{holiday.isPartialDay ? 'Yes' : 'No'}</PropertyListItem>
  </PropertyList>
</Card> : null;
